export class FilterPagination {

  constructor(
    public from?: number,
    public to?: number,
    public orderBy?: string,
    public filter?: string,
    public filterObject?: {}
  ) { }

  getODataQuery(): string {
    this.setDefault();
    return `?\$filter=${this.filter}&\$top=${this.to}&\$skip=${this.from}&\$orderby=${this.orderBy}`;
  }

  private setDefault() {
    if (!this.from) {
      this.from = 0;
    }
    if (!this.to) {
      this.from = 24;
    }
    if (!this.orderBy) {
      this.orderBy = 'data/code/iv';
    }
    if (!this.filter) {
      this.filter = 'data/deleted/iv ne true';
    }
  }
}
